// import store from "../redux/store";

import { getItem } from "./localStorageUtils";

export function getOrgDetails() {
    const organizationId = getItem("organizationId");
    return organizationId ? organizationId : {};
}